import { Component, Input } from '@angular/core';

@Component({
  selector: 'm-page-container',
  template: `
    <div class="m-page-container" [class.m-page-container-padding]="mPadding">
      <div>
        <ng-content></ng-content>
      </div>
    </div>
  `
})
export class MPageContainerComponent {
  @Input() mPadding = true;
}
